import useTranslation from 'next-translate/useTranslation'
import { Dispatch, SetStateAction } from 'react'

import CryptoNumber from '../CryptoNumber'

export type MaxAmountProps = {
  disabled: boolean
  isValid: boolean
  loading: boolean
  maxAmount: string
  prefix: string
  showMaxSelector: boolean
  setInputValue?: Dispatch<SetStateAction<string>>
  setShowDisplayValue?: Dispatch<SetStateAction<boolean>>
}

function MaxAmount({
  disabled = false,
  isValid = true,
  loading = false,
  maxAmount = '0',
  prefix,
  showMaxSelector = true,
  setInputValue,
  setShowDisplayValue
}: MaxAmountProps) {
  const { t } = useTranslation()

  const handleMaxClick = function () {
    if (maxAmount) {
      setInputValue(maxAmount)
      setShowDisplayValue(true)
    }
  }

  return (
    <div className="flex gap-2 font-sans">
      <div
        className={`flex min-w-[7rem] items-center justify-end ${
          !isValid ? 'text-red-600' : ''
        }`}
      >
        <CryptoNumber
          loading={loading}
          prefix={prefix && `${prefix}: `}
          value={maxAmount || 0}
        />
      </div>

      {showMaxSelector && (
        <span
          className={`text-teal-primary text-xs font-semibold uppercase ${
            disabled || !maxAmount ? 'cursor-not-allowed' : 'cursor-pointer'
          }`}
          data-sentry="max-selector"
          onClick={handleMaxClick}
        >
          {t('max')}
        </span>
      )}
    </div>
  )
}

export default MaxAmount
